//@flow

const _ = require('lodash');
const ko = require('knockout');

import editButton from '../templates/bits/edit-button.html';
import editFioModal from '../templates/edit-fio-modal.html';
import page from 'page-common';

export type MyInsurancesControllerOptions2 = {
	config: any,
}

module.exports = class FiInputModel {

	constructor (params) {
		params = _.defaultsDeep({}, params, {
			fullName: {
				attr: {
					placeholder: "Петров Алексей Иванович",
				},
				jqInputcapitalize: 'titlecase',
			},
			firstName: {
				attr: {
					placeholder: "Алексей",
				},
				jqInputcapitalize: 'titlecase',
			},
			lastName: {
				attr: {
					placeholder: "Петров",
				},
				jqInputcapitalize: 'titlecase',
			},
			middleName: {
				attr: {
					placeholder: "Иванович",
				},
				jqInputcapitalize: 'titlecase',
			},
			labelPrefix: {},
			labelSuffix: {},
			labelSplitedText: {},
			labelSplitedInfo: {},
			withInfoSuffix: false,
			infoSuffixText: '',
			required: false,
			gtmProcessing: {
				startEventValue: '',
				successEventValue: '',
				failureEventValue: '',
				focusEventParams: undefined,
			},
			isFioChangeEnabled: false,
			disable: false,
			lockedFields: {
				firstName: false,
				lastName: false,
				middleName: false,
			},
			onlySplitMode: false,
			calculatorFeedbackModal: {},
			pageUrls: '',
		});

		this._params = params;

		// Observables for each name
		const lastName = this._lastName = params.lastName.value;
		const firstName = this._firstName = params.firstName.value;
		const middleName = this._middleName = params.middleName.value;
		this._fullValidity = ko.pureComputed(
			() => lastName.isValid() && firstName.isValid() && middleName.isValid()
		).extend({
			equal: {
				params: true,
				message: 'Введите ФИО',
			},
		});

		// Full name computed based on three separate names
		this._fullName = ko.computed({
			read: function () {
				const last = _.trim(ko.unwrap(lastName) || '');
				const first = _.trim(ko.unwrap(firstName) || '');
				const middle = _.trim(ko.unwrap(middleName) || '');

				return last
					+ (first ? (' ' + first) : '')
					+ (middle ? (' ' + middle) : '');
			},
			write: function (full) {
				const words = _.filter(full.split(/\s+/g), _.identity);
				lastName(words[0]);
				firstName(words[1]);
				middleName(words.slice(2).join(' '));
			},
		}).extend({
			editable: () => { // HACK: calc-osago editable support
				return _([
					'_lastName',
					'_firstName',
					'_middleName',
				])
					.flatMap(key => this[key]._editable && this[key]._editable())
					.filter()
					.value();
			},

		});

		this._mode = ko.oneOf([ // Current mode of widget
			'combined', // One field mode
			'split', // Three fields mode
		]);

		this._activeName = ko.oneOf([ // Currently active part of name
			null, // none (e.g. when field is blured)
			'last', // editing last name
			'first', // edititng first name
			'middle', // edititng middle name
		]);

		this._lastNameHasFocus = ko.observable();
		this._firstNameHasFocus = ko.observable();
		this._middleNameHasFocus = ko.observable();

		// Watch word count and switch to 'multiple' mode when necessary
		ko.computed(() => {
			const middle = _.trim(ko.unwrap(middleName) || '');
			const wordCount = (middle.match(/\s+/g) || []).length + 1;
			if (wordCount > 1) {
				this._mode('split');

				// Focus an input
				const toBeFocused = ({
					last: this._lastNameHasFocus,
					first: this._firstNameHasFocus,
					middle: this._middleNameHasFocus,
				}[this._activeName()]);
				if (toBeFocused) {
					toBeFocused(true);
				}
			}
		});

		ko.computed(() => {
			if (ko.unwrap(params.onlySplitMode)) {
				this._mode('split');
			}
		});

		this._sendRequestModal = this._createSendRequestModal(params.pageUrls);
	}

	_updateActiveName (fullNameInput) {
		const value = fullNameInput.value;
		const caret = fullNameInput.selectionStart;
		const beforeCaret = value.slice(0, caret).replace(/\s+/g, ' ').replace(/^\s*/, '');
		const wordsBeforeCaret = beforeCaret.split(' ').length - 1;

		this._activeName(['last', 'first'][wordsBeforeCaret] || 'middle');
	}

	_onFullNameBlur () {
		this._activeName(null);
		return true;
	}

	_onFullNameClick (data, e) {
		this._updateActiveName(e.target);
		return true;
	}

	_onFullNameKeyup (data, e) {
		this._updateActiveName(e.target);
		return true;
	}

	_editFioButtonTemplate () {
		return editButton();
	}

	_onEditFioClick () {
		page.modals.show(this._sendRequestModal);
	}

	_createSendRequestModal (pageUrls): any {
		if (pageUrls)
		{
			return page.modals.create({
				templateMode: 'nfd-content',
				template: {
					html: editFioModal(),
					data: {
						props: {
							complaintsUrl: pageUrls.currentSite.complaints
						},
					}
				},
				css: {'nfd-modal-lg-half': true},
			});
		}
	}
};
